import React from 'react';

import { Container } from 'Components/core';

import Content from './InfoBoxContent';
import Header from './InfoBoxHeader';
import Hero from './InfoBoxHero';
import ContainterV2 from 'Components/core/ContainterV2';
import styled from 'styled-components';
import { layout } from 'Constants';

const ChildrenWrapper = styled.div`
  padding: 0px 110px ${props => (props.compact ? '0px' : '90px')} 118px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 0px 10px 0px 10px;
  }
`;

export default ({ header, image, longText, compact=false ,children}) => {
  return (
    <ContainterV2
      image={image}
      heroText={header}
      longText={longText}
      column
    >
      <ChildrenWrapper compact={compact}>{children}</ChildrenWrapper>
    </ContainterV2>
  );
};
